import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const HEAT_EXCHANGER_CONFIG = {
    type: ERFElement.HeatExchanger,
    icon: 'HeatExchanger_2d',
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_annular_space_flow',
                    type: 'target',
                    name: 'Входной поток межтрубного пространства',
                    position: Position.Left,
                    style: { top: 37, left: 12, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'target_material_tubular_space_flow',
                    type: 'target',
                    name: 'Входной поток трубного пространства',
                    position: Position.Top,
                    style: { top: 13, left: 37, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_tubular_space_flow',
                    type: 'source',
                    name: 'Выходной поток трубного пространства',
                    position: Position.Right,
                    style: { top: 37, right: 11, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                {
                    id: 'source_material_annular_space_flow',
                    type: 'source',
                    name: 'Выходной поток межтрубного пространства',
                    position: Position.Bottom,
                    style: { top: 56, left: 37, background: M_FLOW_HEX },
                    connectionCount: 1
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 54, left: 18, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 54, right: 18, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFHeatExchangerNode.config.js.map